<template>
  <div>
    <TopBar />
    <Sidebar />
    <AppMain />
  </div>
</template>

<script>
import { TopBar, Sidebar, AppMain } from './components'
export default {
  name: 'Layout',
  components: {
    TopBar,
    Sidebar,
    AppMain
  }
}
</script>